module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/s1lSld/tc-custom/9781781316580.jpg?1702535260944",
      "alt": "This image is the cover for the book Sail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sail\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A celebration of sailing, featuring profiles on the world’s greatest races & sailors, as well as technical analysis of some of the best racing boats.")]), _c('br'), _c('br'), _vm._v("Whether it is to test the high seas on around-the-world events in the glory of 49er yachts, to cut through choppy coastal waters on a Lazer racing for Olympic Gold or to set team against team in the great cup challenges, "), _c('i', [_vm._v("Sail")]), _vm._v(" is a celebration of the adventure and skill of one of mankind’s oldest sports."), _c('br'), _c('br'), _vm._v("Including chapters on the greatest races and their class divisions and the incredible and inspirational stories of the world’s greatest sailors—from Ellen MacArthur to Seve Jarvin, Tony Bullimore to Vinny Lauwers—homage is paid to those who have mastered their boats and set out to conquer the seas."), _c('br'), _c('br'), _c('i', [_vm._v("Sail")]), _vm._v(" also includes detailed technical analysis and intricate illustrations on each classification of racing boat, explained by the experts in their field, to give a complete account of the world of sailing competition.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Timothy Jeffery, Ben Ainslie\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aurum Press Ltd\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0